import authorization from '../../../icons/authorization.svg';
import { Image } from 'office-ui-fabric-react';
import './AuthorizationIcon.scss';

const AuthorizationIcon = ({ onClick }: { onClick?: () => void }) => {
    return (
        <div className="containerIconCard" onClick={onClick} style={{ cursor: 'pointer' }}>
            <Image src={authorization} alt="Autorización" />
        </div>
    );
};

export default AuthorizationIcon;